/* eslint-disable no-undef */
import { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { useProductContext } from "./context/productcontex";
import PageNavigation from "./components/PageNavigation";
import { Container } from "./styles/Container";
// import { FiMessageSquare } from "react-icons/fi"; // Import the floating icon


const SingleProduct = () => {
  const { getSingleProduct, isSingleLoading, singleProduct } =
    useProductContext();
  const [showContactForm, setShowContactForm] = useState(false); // State for managing form visibility

  const { id } = useParams();

  const {
    name,
    company,
      category,
    description,
      embed,
      link,
      reachoutmessage,

  } = singleProduct;


useEffect(() => {
  getSingleProduct(id);
}, [id, getSingleProduct]);

  const toggleContactForm = () => {
    setShowContactForm((prev) => !prev);
  };
  if (isSingleLoading) {
    return <div className="page_loading">Loading.....</div>;
  }

  return (
    <Wrapper>
      <PageNavigation title={name} />
      <Container className="container">
        <div className="grid grid-two-column">

          <div className="product-data">
            <h2>{name}</h2>

            {description}
            </div>

            <div className="product-data-info">
              <p>
                Model Type : <span> {category} </span>
              </p><br />
              <p>
                Industry Sector:<span> {company} </span>
              </p><br />
              <p>
                <span> {reachoutmessage} </span>
              </p><br />
{link && (
              <p>
                Live Project:{" "}
                <span className="try-yourself">
                  <button className="btn" onClick={() => window.open(link, "_blank")}>
                    Try Yourself!
                  </button>
                </span>
              </p>
            )}        <br/>
              <br/>
              <br/>
              <br/>
            <div className="product-video">
              <div dangerouslySetInnerHTML={{ __html: embed }} />
            </div>

            </div>


          </div>
<br/><br/><br/><br/><br/>

          <FloatingIcon onClick={toggleContactForm}>
          <span>Reach out to us</span>
        </FloatingIcon>

        {showContactForm && (
          <Modal>
            <div className="contact-form">
              <br />
              <form
                action="https://formspree.io/f/moqobbry"
                method="POST"
                className="contact-inputs"
              >

            <input
              type="text"
              placeholder="Your Name"
              name="Name"
              required
              autoComplete="off"
            />

            <input
              type="email"
              name="Email"
              placeholder="Your Business Email"
              autoComplete="off"
              required
            />
            <input
                type="tel"
                name="PhoneNumber"
                placeholder="Your Contact Number (Optional)"
                autoComplete="off"
              />
            <textarea
              name="Message"
              cols="30"
              rows="10"
              required
              autoComplete="off"
        defaultValue={name ? `I am interested in ${name}.` : ''}
            />




            <input type="submit" value="send" /> <CloseButton onClick={toggleContactForm}>Close</CloseButton>
              </form>
            </div>
          </Modal>
        )}
      </Container>
    </Wrapper>
  );
};
const FloatingIcon = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #3498db;
  color: #fff;
  font-size: 24px;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;

  span {
    margin-left: 5px;
  }
`;

const Modal = styled.div`
  position: fixed;
  top: 10%;
  left: 25%;

  width: 100%;
  height: 100%;
// background: rgba(20, 20, 20, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  padding:;
`;

const CloseButton = styled.button`
  background-color: #3498db;
  color: #fff;
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 10px;
  width: 38%;
`;
const Wrapper = styled.section`
  .container {
    padding: 9rem 0;
  }
   iframe {
    width: 100%; /* Default width for mobile view */
    height: 75vw; /* Adjust this as needed */

    @media (min-width: 768px) {
      /* Change dimensions for desktop view */
      width: 100%; /* 50% of the container width */
      height: 25vw; /* Adjust this as needed */
    }
  }
.try-yourself .btn {
  background-color: #5dade2; /* Light bluish grey color */
  color: #fff; /* White text color */
  padding: 5px 20px; /* Add padding to the button */
  font-size: 30px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease; /* Add a smooth transition effect */

  &:hover {
    background-color: #3498db; /* Darker color on hover */
  }
}

.contact-form {
        max-width: 50rem;
        margin: auto;

        .contact-inputs {
          display: flex;
          flex-direction: column;
background: rgba(5, 20, 50, 0.85);
          padding: 20%;
          width: 200%;
          gap: 1.5rem;

          input[type="submit"] {
            cursor: pointer;
            transition: all 0.2s;

            &:hover {
              background-color: ${({ theme }) => theme.colors.white};
              border: 1px solid ${({ theme }) => theme.colors.btn};
              color: ${({ theme }) => theme.colors.btn};
              transform: scale(0.9);
            }
          }
        }
      }


  .product-data {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 2rem;


   .product-data-info {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      font-size: 1.8rem;

      span {
        font-weight: bold;
      }
    }

}

  .page_loading {
    font-size: 3.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: ${({ theme }) => theme.media.mobile}) {
    padding: 0 2.4rem;
  }
`;

export default SingleProduct;